import { IEstimate } from 'types';

export const isEstimateAutobuild = (estimate?: IEstimate) => {
  if (estimate) {
    const { locations = [] } = estimate;
    return locations.length ? locations.every((l) => l.isAutobuild) : true;
  }
  return true;
};
